import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { SharedButton, StyledWelcome } from "@components";
import { PATH_SIGN_UP, enumExternalMethod } from "@configs";
import liff from "@line/liff";
import { resetAuthState, selectMerchant, setExternalLogin } from "@redux";
import { Skeleton } from "antd";
import { useEffect, useState } from "react";
import { SkeletonLoading, SkeletonType } from "src/Components/shared/SkeletonLoading";
import useCache from "src/Store/useCache";

export const PageWelcome = () => {
    //page hook
    const { t } = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();
    //redux state
    const { themes, signUpSettings, name } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const [isLoading, setIsloading] = useState(true);

    const handleClick = async () => {
        if (
            (merchant?.signUpSettings?.signUpMethod === enumExternalMethod.LINEOA_TEL ||
                merchant?.signUpSettings?.signUpMethod === enumExternalMethod.LINE) &&
            liff.isInClient()
        ) {
            sessionStorage.setItem("DISABLE_APP_ROUTE", "true");
        }
        await dispatch(
            setExternalLogin({
                type: enumExternalMethod.TEL,
                isSignUp: false,
                line: {
                    code: "",
                    state: "",
                },
            })
        );
        useCache.setState({ isReady: false });

        history.replace(PATH_SIGN_UP);
    };

    useEffect(() => {
        dispatch(resetAuthState());
        // dispatch(setMerchantSetting());
        setTimeout(() => {
            setIsloading(false);
            for (let key in localStorage) {
                if (key !== "SURVEY") {
                    localStorage.removeItem(key);
                }
            }
            for (let key in localStorage) {
                if (key !== "QRCODE") {
                    localStorage.removeItem(key);
                }
            }
        }, 1000);
    }, []);

    return (
        <StyledWelcome themeColor={themes?.themeColor!}>
            <SkeletonLoading type={SkeletonType.box} height={120} style={{ marginBottom: 8 }} />
            <SkeletonLoading type={SkeletonType.input} style={{ marginBottom: 8 }} />
            <SkeletonLoading type={SkeletonType.button} style={{ marginBottom: 8 }} />
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <SkeletonLoading type={SkeletonType.avatar} size={20} />
                <SkeletonLoading type={SkeletonType.line} sizes={[10]} />
            </div>
            <SkeletonLoading
                type={SkeletonType.line}
                sizes={[50, 100, 100]}
                style={{ justifySelf: "center", marginBottom: 8 }}
            />

            <div className="box_top">
                <div className="welcome text-header">{t("page.welcome")}</div>
                <div className="des-skeleton">
                    <Skeleton
                        loading={isLoading}
                        active
                        title={false}
                        paragraph={{ rows: 2, width: [260, 132] }}
                    >
                        <div className="desc text-sub-header">
                            {t("page.become_welcome")} {name}
                            <br />
                            {t("page.desc_welcome")}
                        </div>
                    </Skeleton>
                </div>
                <div className="btn-skeleton">
                    <Skeleton loading={isLoading} active title={false} paragraph={{ rows: 1 }}>
                        <SharedButton
                            className="btn-text"
                            size="large"
                            bg_color={themes?.themeColor!}
                            width="90%"
                            onClick={handleClick}
                        >
                            {t("page.become")}
                        </SharedButton>
                    </Skeleton>
                </div>
            </div>
            <div className="group_images">
                <Skeleton loading={isLoading} active title={false} paragraph={{ rows: 2 }}>
                    {signUpSettings?.welcomeScreenImages?.map((item) => {
                        return <img key={item} src={item} />;
                    })}
                </Skeleton>
            </div>
        </StyledWelcome>
    );
};
